import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import ErrorHandler from '../../lib/errorHandler';
import React, { useEffect, useState } from 'react';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import CommonLabel from '../../Component/Common/CommonLabel';
import NoDataFound from '../../Component/Common/NoDataFound';
import { getVendors, image } from '../../Redux/Actions/Vendor';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { isCompleteDate, standardDateFormat } from '../../lib/standardDateFormat';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import IconBackground from '../../Component/Common/IconBackground';
import { categoryNameOptions, useCommonStyles } from '../../utils';
import CommonTextField from '../../Component/Common/CommonTextField';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import CommonDatePicker from '../../Component/Common/CommonDatePicker';
import CommonFileUpload from '../../Component/Common/CommonFileUpload';
import CommonAutoComplete from '../../Component/Common/CommonAutoComplete';
import { getPoDcumentsByPoNumber } from "../../Redux/Actions/PurchaseOrder";
import { addPODocument, getAdvanceLicensesForPODoc, getPODocumetsPoNumbers, getPurchaseOrderById, getPurchaseOrders, updatePODocument } from '../../Redux/Actions/PurchaseOrder';
import { Box, Button, Grid, useTheme, Typography, Breadcrumbs, TableContainer, Table, TableHead, TableBody, Tabs, Tab } from '@mui/material';
import { useConfirm } from 'material-ui-confirm';
import ErrorMessage from '../../Component/Common/ErrorMessage';
import { BUCKET_URL } from '../../ApiSetUp/AuthApi';

const useStyles = makeStyles()((theme) => ({
    customTabStyle: {
        margin: "30px",
        "& .MuiTabs-flexContainer": {
            gap: "10px",
        },
        "& .MuiTab-root": {
            backgroundColor: "transparent",
            alignItems: "start",
            color: "#555151",
            fontFamily: "Satoshi-Light",
            minWidth: "0px",
            fontSize: "18px"
        },
        "& .Mui-selected": {
            fontFamily: "Satoshi-Bold",
            color: theme.palette.primary.main
        },
        "& .MuiTabs-indicator": {
            display: "none"
        }
    },
}))

const poDocumentSteps = [
    { name: "Basic Details", value: 0, mainKey: "basicDetails" },
    { name: "PI Details", value: 1, mainKey: "piDetails", subKey: "piDocument" },
    { name: "BL Details", value: 2, mainKey: "blDetails", subKey: "blDocument" },
    { name: "Document Set", value: 3, mainKey: "documentSetDetails", subKey: "documentSetDocument" },
    { name: "BOE Details", value: 4, mainKey: "boeDetails", subKey: "boeDocument" },
    { name: "Swift Copy", value: 5, mainKey: "swiftCopyDetails", subKey: "swiftCopyDocument" },
    { name: "Debit Advice", value: 6, mainKey: "debitAdviceDetails", subKey: "debitAdviceDocument" },
    { name: "Eway", value: 7, mainKey: "ewayDetails", subKey: "ewayDocument" },
    { name: "Invoice", value: 8, mainKey: "invoiceDetails", subKey: "invoiceDocument" },
    { name: "Packing List", value: 9, mainKey: "packingListDetails", subKey: "packingListDocument" },
    { name: "PIMS", value: 10, mainKey: "pimsDetails", subKey: "pimsDocument" },
];
const advanceLicenseOption = [
    { name: "Yes", value: true },
    { name: "No", value: false },
];

const paymentStatusOptions = [
    { id: 1, name: "Pending" },
    { id: 2, name: "Partially Done" },
    { id: 3, name: "Complete" },
];
const AddUpdatePo = ({ setIsEditMode, isEditMode, setIsOpenAddUpdateDocuments, setData, data, selectedItem, setSelectedItem, _getPODocuments, setSearchValue }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const { classes: muiClasses } = useStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();
    const confirmDialogue = useConfirm();
    // ============== States ==============
    const [errors, setErrors] = useState({});
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState({ name: "Basic Details", value: 0, mainKey: "basicDetails" },);
    const [vendorPage, setVendorPage] = useState(1);
    const [vendorTotalCount, setVendorTotalCount] = useState();
    const [vendorList, setVendorList] = useState([]);
    const [vendorOptions, setVendorOptions] = useState([]);
    const [searchVendor, setSearchVendor] = useState();


    const [poNumberPage, setPoNumberPage] = useState(1);
    const [poNumberTotalCount, setPoNumberTotalCount] = useState();
    const [poNumberList, setPoNumberList] = useState([]);
    const [poNumberOptions, setPoNumberOptions] = useState([]);
    const [searchPoNumber, setSearchPoNumber] = useState();

    const [advanceLicensePage, setAdvanceLicensePage] = useState(1);
    const [advanceLicenseTotalCount, setAdvanceLicenseTotalCount] = useState();
    const [advanceLicenseList, setAdvanceLicenseList] = useState([]);
    const [advanceLicenseOptions, setAdvanceLicenseOptions] = useState([]);
    const [searchAdvanceLicense, setSearchAdvanceLicense] = useState();
    const [advanceLicense, setAdvanceLicense] = useState(false);
    const [advanceLicenseNumber, setAdvanceLicenseNumber] = useState("");

    // console.log("advanceLicense", advanceLicense)

    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => { setIsOpenAddUpdateDocuments(false); setSelectedItem({}); setData({}); setIsEditMode(false); setSearchValue("") }}>
            Document List
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {`${isEditMode ? "Edit" : "Add New"} Document`}
        </Typography>,
    ];
    // ============== Handler ==============
    const tabelHeader = ["document", "DATE", "Size", "Action"]
    const handleUpdatePreviousValue = () => {
        const temp = poDocumentSteps?.find((ele) => ele?.value == value - 1)
        setValue(value - 1)
        setActiveTab(temp)
    }
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };
    const handleChange = (mainKey, name, value) => {
        if (name == "hazira") {
            const pickupDate = value
                ? new Date(new Date(value).setDate(new Date(value).getDate() + 14))
                : null;
            setData((prev) => ({
                ...prev,
                [mainKey]: {
                    ...prev[mainKey],
                    [name]: value,
                    pickupDate: pickupDate
                }
            }));
        } else {
            setData((prev) => ({
                ...prev,
                [mainKey]: {
                    ...prev[mainKey],
                    [name]: value,
                }
            }));
        }
    }
    const handleDeleteImage = (rowToDelete) => {
        setData((prev) => {
            const updatedData = { ...prev };
            const mainKey = activeTab?.mainKey;
            const subKey = activeTab?.subKey;
            if (updatedData[mainKey] && updatedData[mainKey][subKey]) {
                updatedData[mainKey][subKey] = updatedData[mainKey][subKey].filter(
                    (row) => row.image !== rowToDelete.image
                );
            }
            return updatedData;
        });
    };
    // ============== Get PO Number API ==============
    const _getPoNumber = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : poNumberPage,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getPODocumetsPoNumbers(body));
        { (poNumberList?.length !== poNumberTotalCount) && setPoNumberPage(poNumberPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPoNumber(searchText ? searchText : "");
            setPoNumberTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setPoNumberList([...poNumberList, ...response?.payload?.data?.response]);
            }
        }
    };

    console.log(poNumberList, "poNumberList")
    const handleChangeInputForPoNumber = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getPODocumetsPoNumbers(body));
        setPoNumberPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchPoNumber(searchText);
            setPoNumberList(response?.payload?.data?.response);
        }
    };

    //------------------  Advance License API ------------------
    const _getAdvanceLicense = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : advanceLicensePage,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getAdvanceLicensesForPODoc(body));
        { (advanceLicenseList?.length !== advanceLicenseTotalCount) && setAdvanceLicensePage(advanceLicensePage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchAdvanceLicense(searchText ? searchText : "");
            setAdvanceLicenseTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setAdvanceLicenseList([...advanceLicenseList, ...response?.payload?.data?.response]);
            }
        }
    };

    const handleChangeInputForAdvanceLicense = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : ""
        };
        response = await dispatch(getAdvanceLicensesForPODoc(body));
        setAdvanceLicensePage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchAdvanceLicense(searchText);
            setAdvanceLicenseList(response?.payload?.data?.response);
        }
    };
    // ============== Get Vendor API ==============
    const _getVendor = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p ? p : vendorPage,
            "search": searchText ? searchText : "",
            "isBlackListed": false,
        };
        response = await dispatch(getVendors(body));
        { (vendorList?.length !== vendorTotalCount) && setVendorPage(vendorPage + 1) }
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchVendor(searchText ? searchText : "");
            setVendorTotalCount(response?.payload?.data?.count);
            if (response?.payload?.data) {
                setVendorList([...vendorList, ...response?.payload?.data?.response]);
            }
        }
    };
    const handleChangeInputForVendor = async (p, searchText) => {
        let response;
        let body = {
            "limit": 10,
            "page": p,
            "search": searchText ? searchText : "",
            "isBlackListed": false,
        };
        response = await dispatch(getVendors(body));
        setVendorPage(2);
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSearchVendor(searchText);
            setVendorList(response?.payload?.data?.response);
        }
    };

    const validStep = () => {
        let formIsValid = true;
        let errors = {};

        if (!data?.basicDetails?.poNumber?.poNumber) {
            formIsValid = false;
            setSnackBar("error", "Please Select PO Number.")
        }
        if (data?.basicDetails?.advanceLicense?.name == "Yes") {
            if (!data?.basicDetails?.advanceLicenseNumber) {
                formIsValid = false;
                setSnackBar("error", "Please Select Advance License Number.")
            }

        }
        if (data?.basicDetails?.poDate) {
            if (!isCompleteDate(data?.basicDetails?.poDate)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid PO date")
            }
        }
        if (data?.basicDetails?.hazira) {
            if (!isCompleteDate(data?.basicDetails?.hazira)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid hazira date")
            }
        }
        if (data?.basicDetails?.pickupDate) {
            if (!isCompleteDate(data?.basicDetails?.pickupDate)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid pickup date")
            }
        }
        if (data?.boeDetails?.boeDate) {
            if (!isCompleteDate(data?.boeDetails?.boeDate)) {
                formIsValid = false;
                setSnackBar("error", "Please select valid boe date")
            }
        }

        setErrors(errors);
        return formIsValid;
    }

    // ============= add Inventory Field API =============
    const _addUpdatePo = async () => {
        if (validStep()) {
            setFullPageLoader(true);
            let response;
            let body = {
                "basicDetails": {
                    "poNumber": data?.basicDetails?.poNumber?.poNumber,
                    "poDate": data?.basicDetails?.poDate ? dayjs(data?.basicDetails?.poDate).format("YYYY-MM-DD") : null,
                    "vendorName": data?.basicDetails?.vendor?.name,
                    "category": data?.basicDetails?.category?.name,
                    "hazira": data?.basicDetails?.hazira ? dayjs(data?.basicDetails?.hazira).format("YYYY-MM-DD") : null,
                    "shippingLine": data?.basicDetails?.shippingLine,
                    "paymentStatus": data?.basicDetails?.paymentStatus?.name,
                    "pickupDate": data?.basicDetails?.pickupDate ? dayjs(data?.basicDetails?.pickupDate).format("YYYY-MM-DD") : null,
                    "advanceLicenseNumber": String(data?.basicDetails?.advanceLicenseNumber) ?? null,
                },
                "piDetails": data?.piDetails,
                "blDetails": data?.blDetails,
                "documentSetDetails": {
                    "documentSet": data?.documentSetDetails?.documentSet?.name,
                    "documentSetDocument": data?.documentSetDetails?.documentSetDocument
                },
                "boeDetails": {
                    "boeDate": data?.boeDetails?.boeDate ? dayjs(data?.boeDetails?.boeDate).format("YYYY-MM-DD") : null,
                    "boeNumber": data?.boeDetails?.boeNumber,
                    "boeDocument": data?.boeDetails?.boeDocument
                },
                "swiftCopyDetails": data?.swiftCopyDetails,
                "debitAdviceDetails": data?.debitAdviceDetails,
                "ewayDetails": data?.ewayDetails,
                "invoiceDetails": data?.invoiceDetails,
                "packingListDetails": data?.packingListDetails,
                "pimsDetails": data?.pimsDetails,

            }
            if (selectedItem?._id) {
                body._id = selectedItem?._id
            }

            const fn = selectedItem?._id ? updatePODocument : addPODocument
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    if (value == 0) {
                        setSnackBar("success", response?.payload?.message)
                    }
                    setSelectedItem(response?.payload?.data?.response)
                    const temp = poDocumentSteps?.find((ele) => ele?.value == value + 1)
                    setValue(value + 1)
                    setActiveTab(temp)
                    if (value === poDocumentSteps?.length - 1) {
                        setSelectedItem({})
                        setIsOpenAddUpdateDocuments(false)
                        setIsEditMode(false)
                        _getPODocuments();
                        setSearchValue("")
                        setData({});
                    }
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    }

    // console.log(data, "data")
    const _gteadvanceLicenseDetails = async () => {
        try {
            const poNumber = data?.basicDetails?.poNumber?.poNumber;
            const body = { poNumber: String(poNumber) };
            const response = await dispatch(getPoDcumentsByPoNumber(body));
            const advanceLicenseData = response?.payload?.data?.response;
            if (advanceLicenseData.advanceLicenses == false) {
                setAdvanceLicense(false);
                setAdvanceLicenseNumber("")
                return;
            }

            if (advanceLicenseData?._id) {
                setAdvanceLicense(true);
                setAdvanceLicenseNumber(advanceLicenseData.advanceLicensesNumber);
                handleChange(
                    activeTab.mainKey,
                    "advanceLicenseNumber",
                    advanceLicenseData.advanceLicensesNumber
                )
            }

        } catch (error) {
            console.error(" STEP ERROR: Error fetching Advance License:", error);
        }
    };



    console.log(advanceLicenseOptions, "advanceLicenseOptions")

    useEffect(() => {
        _gteadvanceLicenseDetails();
    }, [data?.basicDetails?.poNumber?.poNumber]);



    // ============= File Upload API =============
    const handleUploadImg = async (files, name, keyName) => {
        setFullPageLoader(true);
        const formData = new FormData();
        Array.from(files).forEach((file) => {
            formData.append("image", file);
        });
        let response = await dispatch(image(formData));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                const imageUrl = response?.payload?.data;
                if (imageUrl) {
                    setData((prev) => ({
                        ...prev,
                        [name]: {
                            ...prev[name],
                            [keyName]: [
                                ...(prev[name]?.[keyName] || []),
                                ...(Array.isArray(imageUrl) ? imageUrl : [imageUrl])
                            ]
                        }
                    }));
                }
            }
        }
        setFullPageLoader(false);
    };

    // ============= Get By Id Inventory Field API =============
    const _getPurchaseOrderById = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getPurchaseOrderById(body));
        // console.log(response, "response")
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                const res = response?.payload?.data?.response
                // console.log(response, "res")
                const idByData = (id, list) => {
                    const tempdata = list?.find((ele) => ele?.id == id)
                    return tempdata
                }
                setData({
                    ...data,
                    basicDetails: {
                        ...data?.basicDetails,
                        poDate: res?.poDate,
                        vendor: { name: res?.vendorName },
                        category: idByData(res?.category, categoryNameOptions),
                    }
                })
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    useEffect(() => {
        if (
            data?.basicDetails?.advanceLicenseNumber !== undefined &&
            data?.basicDetails?.advanceLicenseNumber !== null &&
            data?.basicDetails?.advanceLicenseNumber !== ""
        ) {
            setAdvanceLicense(true);
        }
    }, [data]);




    // ============= Use Effects =============
    useEffect(() => {
        if (activeTab.value == 0) {
            _getVendor();
        }
    }, [activeTab])

    useEffect(() => {
        _getPoNumber();
        _getAdvanceLicense();
    }, []);

    useEffect(() => {
        const advanceLicenseNumbers = advanceLicenseList.map(
            item => item.advanceLicenseNo
        );
        setAdvanceLicenseOptions(advanceLicenseNumbers)
    }, [advanceLicenseList]);

    // console.log("data?.basicDetails?.advanceLicenseNumber", data?.basicDetails?.advanceLicenseNumber)

    useEffect(() => {
        if (data?.basicDetails?.poNumber?.poNumber && !isEditMode) {
            _getPurchaseOrderById(data?.basicDetails?.poNumber?._id);
        }
    }, [data?.basicDetails?.poNumber]);



    useEffect(() => {
        setPoNumberOptions(poNumberList?.map((e) => e));
    }, [poNumberList]);

    useEffect(() => {
        setVendorOptions(vendorList?.map((e) => e));
    }, [vendorList]);

    // console.log(data, "data")
    return (
        <Box display={"flex"}>
            <Box sx={{ minWidth: "275px", height: "calc(100vh - 84px)", backgroundColor: "#E2E4F8" }}>
                <Tabs value={value} onChange={handleChangeTab} className={muiClasses.customTabStyle}
                    orientation="vertical">
                    {poDocumentSteps.map((ele, index) => (
                        <Tab key={index} onClick={() => setActiveTab(ele)} label={ele.name} />
                    ))}
                </Tabs>
            </Box>
            <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
                <Grid item xs={12}>
                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{`${isEditMode ? "Edit" : "Add New"} Document`}</Typography>
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px", maxHeight: "64vh", overflowY: "auto" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>{activeTab.name}</Typography>
                            </Grid>
                            {activeTab?.value == 0 &&
                                <>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonAutoComplete
                                            label="PO Number"
                                            valid
                                            disabled={isEditMode ? true : false}
                                            placeholder="Select PO Number"
                                            options={poNumberOptions || []}
                                            getOptionLabel={(option) => option?.poNumber || ""}
                                            value={data?.basicDetails?.poNumber || null}
                                            onChange={(e, newValue) => handleChange(activeTab.mainKey, "poNumber", newValue)}
                                            loadData={(poNumberOptions?.length !== poNumberTotalCount) ? _getPoNumber : undefined}
                                            handleSearch={(e) => handleChangeInputForPoNumber(1, e?.target?.value)}
                                            searchValue={searchPoNumber}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonDatePicker
                                            disabled
                                            label={"PO Date"}
                                            onChange={(value) => handleChange(activeTab.mainKey, "poDate", value)}
                                            value={data?.basicDetails?.poDate || null}
                                            name={"poDate"}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonAutoComplete
                                            label="Vendor"
                                            disabled
                                            placeholder="Select Vendor"
                                            options={vendorOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={data?.basicDetails?.vendor || null}
                                            onChange={(e, newValue) => handleChange(activeTab.mainKey, "vendor", newValue)}
                                            loadData={(vendorOptions?.length !== vendorTotalCount) ? _getVendor : undefined}
                                            handleSearch={(e) => handleChangeInputForVendor(1, e?.target?.value)}
                                            searchValue={searchVendor}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonAutoComplete
                                            disabled
                                            label="Category"
                                            placeholder="Select Category"
                                            options={categoryNameOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={data?.basicDetails?.category || null}
                                            onChange={(e, newValue) => handleChange(activeTab.mainKey, "category", newValue)}
                                        />
                                    </Grid>
                                    {
                                        data?.basicDetails?.poNumber?.port == null || "" ? "" : <Grid item xs={12} md={6} lg={4}>
                                            <CommonDatePicker
                                                label={`${data?.basicDetails?.poNumber?.port}`}
                                                onChange={(value) => handleChange(activeTab.mainKey, "hazira", value)}
                                                value={data?.basicDetails?.hazira || null}
                                                name={"hazira"}
                                            />

                                        </Grid>
                                    }
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonTextField
                                            type="text"
                                            label="Shipping Line"
                                            name="shippingLine"
                                            value={data?.basicDetails?.shippingLine}
                                            placeholder="Enter Shipping Line"
                                            onChange={(e) => handleChange(activeTab.mainKey, "shippingLine", e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonAutoComplete
                                            label="Payment Status"
                                            placeholder="Select The Payment Status"
                                            options={paymentStatusOptions || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={data?.basicDetails?.paymentStatus || null}
                                            onChange={(e, newValue) => handleChange(activeTab.mainKey, "paymentStatus", newValue)}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} md={6} lg={4}>
                                        <CommonAutoComplete
                                            label="Advanced License"
                                            placeholder="Yes / No"
                                            options={advanceLicenseOption || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={
                                                data?.advanceLicensesNumber
                                                    ? advanceLicenseOption?.find(opt => opt.name === "Yes")
                                                    : advanceLicenseOption?.find(opt => opt.name === "No")
                                            }
                                            onChange={(e, newValue) =>
                                                handleChange(activeTab.mainKey, "advanceLicense", newValue)
                                            }
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonAutoComplete
                                            label="Advanced License"
                                            placeholder="Yes / No"
                                            options={advanceLicenseOption}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={
                                                advanceLicenseOption.find(
                                                    (opt) => opt.value === advanceLicense
                                                ) || null
                                            }
                                            onChange={(e, newValue) => {
                                                setAdvanceLicense(newValue?.value ?? false);
                                            }}
                                        />
                                    </Grid>

                                    {advanceLicense == true &&
                                        <>
                                            <Grid item xs={12} md={6} lg={4}>
                                                <CommonAutoComplete
                                                    label="Advance License Number"
                                                    placeholder="Select Advance License Number"
                                                    options={advanceLicenseOptions || []}
                                                    getOptionLabel={(option) => option || ""}
                                                    value={
                                                        data?.basicDetails?.advanceLicenseNumber || advanceLicenseNumber || null
                                                    }
                                                    onChange={(e, newValue) =>
                                                        handleChange(
                                                            activeTab.mainKey,
                                                            "advanceLicenseNumber",
                                                            newValue
                                                        )
                                                    }
                                                />
                                            </Grid>


                                            {data?.basicDetails?.advanceLicenseNumber &&
                                                <>
                                                    {/* <Grid item xs={12} md={6} lg={4}>
                                                        <CommonTextField
                                                            valid
                                                            type="number"
                                                            label="Quantity use"
                                                            placeholder="Enter The Quantity"
                                                            name="quantity"
                                                            value={data?.basicDetails?.quantity}
                                                            onChange={(e) => {
                                                                if (+e?.target?.value >= 0) {
                                                                    handleChange(activeTab.mainKey, "quantity", e.target.value)
                                                                } else {
                                                                    return;
                                                                }
                                                            }}
                                                        />

                                                    </Grid>
                                                    <Grid item xs={12} md={6} lg={4}>
                                                        <CommonTextField
                                                            valid
                                                            type="number"
                                                            label="CIF Value"
                                                            placeholder="Enter The CIF Value"
                                                            name="cifValue"
                                                            value={data?.basicDetails?.cifValue}
                                                            onChange={(e) => {
                                                                if (+e?.target?.value >= 0) {
                                                                    handleChange(activeTab.mainKey, "cifValue", e.target.value)
                                                                } else {
                                                                    return;
                                                                }
                                                            }}
                                                        />
                                                    </Grid> */}
                                                </>
                                            }
                                        </>
                                    }
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonDatePicker
                                            disabled
                                            label={"Pickup Date"}
                                            onChange={(value) => handleChange(activeTab.mainKey, "pickupDate", value)}
                                            value={data?.basicDetails?.pickupDate || null}
                                            name={"pickupDate"}
                                        />
                                    </Grid>
                                </>
                            }
                            {activeTab?.value == 1 &&
                                <Grid item xs={12} md={6} lg={4}>
                                    <CommonTextField
                                        type="text"
                                        label="PI Number"
                                        name="piNumber"
                                        value={data?.piDetails?.piNumber}
                                        placeholder="Enter The PI number"
                                        onChange={(e) => handleChange(activeTab.mainKey, "piNumber", e.target.value)}
                                    />
                                </Grid>
                            }
                            {activeTab?.value == 2 &&
                                <Grid item xs={12} md={6} lg={4}>
                                    <CommonTextField
                                        type="text"
                                        label="BL number"
                                        name="blNumber"
                                        value={data?.blDetails?.blNumber}
                                        placeholder="Enter The BL number"
                                        onChange={(e) => handleChange(activeTab.mainKey, "blNumber", e.target.value)}
                                    />
                                </Grid>
                            }
                            {activeTab?.value == 3 &&
                                <Grid item xs={12} md={6} lg={4}>
                                    <CommonAutoComplete
                                        label="Document Set"
                                        placeholder="Yes / No"
                                        options={advanceLicenseOption || []}
                                        getOptionLabel={(option) => option?.name || ""}
                                        value={data?.documentSetDetails?.documentSet || null}
                                        onChange={(e, newValue) => handleChange(activeTab.mainKey, "documentSet", newValue)}
                                    />
                                </Grid>
                            }
                            {activeTab?.value == 4 &&
                                <>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonDatePicker
                                            label={"BOE Date"}
                                            onChange={(value) => handleChange(activeTab.mainKey, "boeDate", value)}
                                            value={data?.boeDetails?.boeDate || null}
                                            name={"boeDate"}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <CommonTextField
                                            type="text"
                                            label="BOE Number"
                                            name="boeNumber"
                                            value={data?.boeDetails?.boeNumber}
                                            placeholder="Enter The boe number"
                                            onChange={(e) => handleChange(activeTab.mainKey, "boeNumber", e.target.value)}
                                        />
                                    </Grid>
                                </>
                            }
                            {activeTab?.value == 8 &&
                                <Grid item xs={12} md={6} lg={4}>
                                    <CommonTextField
                                        type="text"
                                        label="Invoice number"
                                        name="invoiceNumber"
                                        value={data?.invoiceDetails?.invoiceNumber}
                                        placeholder="Enter The Invoice number"
                                        onChange={(e) => handleChange(activeTab.mainKey, "invoiceNumber", e.target.value)}
                                    />
                                </Grid>
                            }
                            {activeTab?.value !== 0 &&
                                <Grid item xs={12} >
                                    <CommonLabel title={activeTab?.value == 1 ? "Upload PI Document" : activeTab?.value == 2 ? "Upload BL Document" : activeTab?.value == 3 ? "Upload Document Set" : activeTab?.value == 4 ? "Upload BOE Document" : activeTab?.value == 5 ? "Upload Swift Copy" : activeTab?.value == 6 ? "Upload Debit Advice" : activeTab?.value == 7 ? "Upload Eway" : activeTab?.value == 8 ? "Upload Invoice" : activeTab?.value == 9 ? "Upload Packing List" : activeTab?.value == 10 ? "Upload PIMS" : "Upload Document"} />
                                    <CommonFileUpload
                                        disabled={(activeTab?.value == 1 && !data?.piDetails?.piNumber) ? true : (activeTab?.value == 2 && !data?.blDetails?.blNumber) ? true : (activeTab?.value == 3 && data?.documentSetDetails?.documentSet?.name == "No") ? true : (activeTab?.value == 4 && !data?.boeDetails?.boeDate && !data?.boeDetails?.boeNumber) ? true : (activeTab?.value == 8 && !data?.invoiceDetails?.invoiceNumber) ? true : false}
                                        isMultiple
                                        handleImageChange={(files) => handleUploadImg(files, activeTab.mainKey, activeTab.subKey)}
                                        accept=".png,.jpeg,.jpg,.pdf,.xls,.xlsx"
                                    />
                                </Grid>
                            }
                            {activeTab?.value !== 0 &&
                                <Grid item xs={12} width={"100px"}>
                                    <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                        <TableContainer>
                                            <Table >
                                                <TableHead>
                                                    <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                                        {tabelHeader?.map((ele) => {
                                                            return (
                                                                <StyledTableCell>{ele}</StyledTableCell>
                                                            )
                                                        })}
                                                    </StyledTableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data?.[activeTab?.mainKey]?.[activeTab?.subKey]?.length > 0 ?
                                                        data?.[activeTab?.mainKey]?.[activeTab?.subKey]?.map((row, index) => (
                                                            <React.Fragment key={index}>
                                                                <StyledTableRow>
                                                                    <StyledTableCell sx={{ borderBottomLeftRadius: index === data?.[activeTab?.mainKey]?.[activeTab?.subKey].length - 1 ? "26px" : "0px" }}> {row?.image?.split("/").pop()}</StyledTableCell>
                                                                    <StyledTableCell> {row.date ? standardDateFormat(row.date) : "NA"}</StyledTableCell>
                                                                    <StyledTableCell sx={{ display: "flex", justifyContent: "start", alignItems: "center", gap: "10px" }}>
                                                                        {row?.size ? row?.size?.toFixed(2) + " MB" : ""}
                                                                        {row?.status && <Typography color={"#4F880A"} fontFamily={"Satoshi-Bold"} fontSize={"14px"}>{row?.status}</Typography>}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell sx={{ borderBottomRightRadius: index === data?.[activeTab?.mainKey]?.[activeTab?.subKey].length - 1 ? "26px" : "0px" }}>
                                                                        <Box display={'flex'} gap={1}>
                                                                            <IconBackground icon="visibility" onClick={() => window?.open(`${BUCKET_URL + row?.image}`)} />
                                                                            {/* <IconBackground icon="download" onClick={() => {}} /> */}
                                                                            <IconBackground icon={"delete"} disabled={row.status === 1}
                                                                                onClick={(e) => {
                                                                                    confirmDialogue({
                                                                                        title: `Are you sure you want to delete?`,
                                                                                    }).then(() => {
                                                                                        handleDeleteImage(row)
                                                                                    }).catch((err) => { console.error(err) });
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            </React.Fragment>
                                                        ))
                                                        :
                                                        <StyledTableRow>
                                                            <StyledTableCell colSpan={12}>
                                                                <NoDataFound />
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                </Grid>
                            }
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12} display={"flex"} justifyContent={"end"} gap={2}>
                    {value != 0 &&
                        <Button className={classes.cancelButton} onClick={() => handleUpdatePreviousValue()} disabled={value == 0}>{activeTab?.value == 0 ? "Cancel" : "Previous"}</Button>
                    }
                    <Button className={classes.saveButton} onClick={() => _addUpdatePo()}>{activeTab?.value == 10 ? "Save" : "Next"}</Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddUpdatePo;
